import React from 'react';

/**
 * Bouton Continuer pour l'onboarding
 */
export default function ContinueButton({
  onClick,
  disabled = false,
  label = 'Continuer',
  variant = 'primary', // 'primary', 'secondary', 'cta'
  icon = true,
  className = '',
}) {
  const variants = {
    primary: `
      bg-gradient-to-r from-emerald-500 to-teal-500 text-white
      ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#26b8a5]'}
    `,
    secondary: `
      bg-white text-[#2DD4BF] border-2 border-[#2DD4BF]
      ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#F0FDFA]'}
    `,
    cta: `
      bg-gradient-to-r from-yellow-400 to-orange-400 text-gray-900 rounded-2xl py-4
      ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:from-orange-500 hover:to-orange-600'}
    `,
  };

  return (
    <button
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={`
        w-full py-4 px-6 rounded-2xl font-semibold text-lg
        flex items-center justify-center gap-2
        transition-all duration-200
        ${variants[variant]}
        ${className}
      `}
    >
      {label}
      {icon && (
        <svg 
          className="w-5 h-5" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M14 5l7 7m0 0l-7 7m7-7H3" 
          />
        </svg>
      )}
    </button>
  );
}
